<div class="card-btn"
     [style.backgroundImage]="'url(' + imageUrl + ')'" >
  <div class="card-btn--screen"></div>
  <div class="card-btn--text">
    <i class="iconlace" [ngClass]="icon"></i>
    <h3>{{ text }}</h3>
  </div>

</div>